import { Component } from '@angular/core';
import { ICellEditorAngularComp } from 'ag-grid-angular';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { ICellEditorParams } from 'ag-grid-enterprise';
import moment from 'moment-timezone';
import {
  convertDateToNgbDate,
  convertStringDateDownToDateFormat,
} from '../../pure-functions/convert-date-to-ngb-date.fn';

@Component({
    selector: 'app-date-cell-editor',
    templateUrl: './date-cell-editor.component.html',
    styleUrls: ['./date-cell-editor.component.scss'],
    standalone: false
})
export class DateCellEditorComponent implements ICellEditorAngularComp {
  private params!: CustomParams;
  public ngbDate?: NgbDate;
  public minDate?: NgbDate;

  agInit(params: CustomParams): void {
    this.params = params;
    const startDate = moment().startOf('day').valueOf();

    if (this.params.startDate) {
      this.ngbDate = convertDateToNgbDate(startDate);
    }

    if (this.params.minDate) {
      this.minDate = convertDateToNgbDate(this.params.minDate);
    }

    if (this.params.value) {
      this.ngbDate = convertDateToNgbDate(params.value);
    }
  }

  getValue(): number | null | string {
    if (this.ngbDate) {
      if (typeof this.params.value === 'string') {
        return convertStringDateDownToDateFormat(this.ngbDate);
      } else if (this.params.value === null) {
        return convertStringDateDownToDateFormat(this.ngbDate);
      } else {
        return moment(
          `${this.ngbDate.year}-${this.ngbDate.month}-${this.ngbDate.day}`,
        ).valueOf();
      }
    }

    return null;
  }

  isPopup(): boolean {
    return false;
  }

  onDateSelection(date: NgbDate) {
    this.ngbDate = date;
    this.params.api?.stopEditing();
  }
}

interface CustomParams extends ICellEditorParams {
  minDate: number;
  startDate: boolean;
}
